import { faAdd } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { FuelTransaction } from '../../../types/FuelTransaction';
import { Dialog } from '../../ui/Dialog';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../ui/Form';
import { Input } from '../../ui/Input';
import { useFuelTransaction } from '../hooks/useFuelTransaction';
import { addFuelTransactionSchema } from '../validation/addFuelTransactionSchema';
import { toast } from 'react-toastify';
import { Button } from '../../ui/Button';
import { AddFuelTransaction as AddFuelTransactionType } from '../../../types/FuelTransaction';

export const AddFuelTransaction = ({ fuelTransaction }: { fuelTransaction?: FuelTransaction }) => {
    const addMutation = useFuelTransaction().addFuelTransaction();
    const [isOpen, setIsOpen] = useState(false);
    const form = useForm<z.infer<typeof addFuelTransactionSchema>>({
        resolver: zodResolver(addFuelTransactionSchema),
        defaultValues: {
            transactionDate: '',
            litersOfFuel: 0,
            amountIncludingVAT: 0,
            kilometersTotal: 0,
        },
    });

    const onSubmit = async (fuelTransaction: AddFuelTransactionType) => {
        addMutation.mutate(fuelTransaction, {
            onSuccess: () => {
                setIsOpen(false);
                form.reset();

                toast('Tankbeurt succesvol toegevoegd.');
            },
        });
    };

    return (
        <>
            <button className="p-3 -m-3 leading-none" onClick={() => setIsOpen((current) => !current)} title="Toevoegen">
                <FontAwesomeIcon icon={faAdd} className="text-lg" />
            </button>

            <Dialog
                open={isOpen}
                onClose={() => {
                    setIsOpen(false);
                    form.reset();
                }}
            >
                <Dialog.Title>Tankbeurt toevoegen</Dialog.Title>

                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-3">
                        <FormField
                            control={form.control}
                            name="transactionDate"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>
                                        Datum <small>(voer handmatig in of klik op kalender)</small>
                                    </FormLabel>
                                    <FormControl>
                                        <Input
                                            placeholder="datum"
                                            {...field}
                                            type="datetime-local"
                                            value={field.value as any}
                                            // onFocus={(e) => e.target.showPicker()}
                                        />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <FormField
                            control={form.control}
                            name="litersOfFuel"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>Aantal liters</FormLabel>
                                    <FormControl>
                                        <Input placeholder="Aantal liters" {...field} type="number" step={0.01} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <FormField
                            control={form.control}
                            name="kilometersTotal"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>Totale kilometerstand</FormLabel>
                                    <FormControl>
                                        <Input placeholder="Kilometerstand" {...field} type="number" step={1} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <FormField
                            control={form.control}
                            name="amountIncludingVAT"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>Bedrag</FormLabel>
                                    <FormControl>
                                        <Input placeholder="Bedrag" {...field} type="number" step={0.01} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <div className="flex justify-end pt-6">
                            <Button loading={addMutation.isPending}>Opslaan</Button>
                        </div>
                    </form>
                </Form>
            </Dialog>
        </>
    );
};
